// Un solo lugar donde se toca el dataLayer. Con Tag Manager o Google Ads
// conectados, estos eventos son las conversiones del sitio; sin contenedor
// instalado quedan en el arreglo y no molestan a nadie.

export function pushEvent (event, payload = {}) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event, ...payload })
}

// Cada clic a WhatsApp. `source` dice qué CTA convirtió.
export function trackConversion (source, subject) {
  pushEvent('whatsapp_click', {
    cta_source: source || 'unknown',
    cta_subject: subject || 'general'
  })
}

// Clic a un CTA que lleva al formulario. Simétrico con whatsapp_click: sin esto
// solo se miran los clics a WhatsApp y el formulario parece el canal chico
// cuando quizá no lo es. `source` dice qué CTA convirtió.
export function trackQuoteCtaClick (source) {
  pushEvent('quote_cta_click', {
    cta_source: source || 'unknown'
  })
}

// Cotización enviada por formulario. Va aparte de whatsapp_click porque son dos
// canales distintos y conviene saber cuál trae mejores contactos.
//
// Este es el evento con el que se cuenta la conversión en Google Ads. `userData`
// trae el correo y el celular hasheados (lib/user_data.js) y viaja en el mismo
// push que el evento, para que el disparador y la variable lleguen juntos: si
// el dato entrara después, la etiqueta ya se habría disparado sin él.
export function trackQuoteSubmit ({ items, blinds, commune, userData = null }) {
  pushEvent('quote_submit', {
    quote_items: items,
    quote_blinds: blinds,
    quote_commune: commune,
    user_data: userData
  })
}

// La URL de "cotización enviada".
//
// El formulario no recarga la página: la respuesta llega por fetch y la tarjeta
// de éxito reemplaza los campos en el sitio. Eso deja la barra de direcciones
// diciendo "/", y quien configure la conversión por URL de destino —que es como
// se hacía toda la vida con un formulario que recargaba— no vería nunca nada.
// Esto le da esa URL. Rails la sirve de verdad (pages#quote_sent), así que
// recargar ahí no cae en un 404.
//
// replaceState y no pushState: con pushState el botón "atrás" devolvería al
// formulario recién enviado, que es un lugar al que nadie quiere volver.
export const QUOTE_SENT_PATH = '/cotizacion-enviada'

export function markQuoteSent () {
  if (!globalThis.window?.history?.replaceState) return

  window.history.replaceState(window.history.state, '', QUOTE_SENT_PATH)
}

// Abrir la ficha de un producto. No es una conversión —nadie compró por mirar—
// pero dice qué se mira, que es lo que decide qué foto vale la pena mejorar.
export function trackProductView (productId) {
  pushEvent('product_view', { product_id: productId || 'unknown' })
}

// Abrir la ficha de una tela. Misma idea que la de un producto, y acá dice algo
// más: qué tela se mira es lo que decide de cuál conviene subir los colores.
export function trackFabricView (fabricName) {
  pushEvent('fabric_view', { fabric_name: fabricName || 'unknown' })
}
